import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import metalService from "./metalService";

export const getMetal = createAsyncThunk(
  "metaltype/all",
  async (thunkAPI) => {
    try {
      return await metalService.getMetals();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAMetal = createAsyncThunk(
  "metaltype/get",
  async (id, thunkAPI) => {
    try {
      return await metalService.getMetal(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createMetal = createAsyncThunk(
  "metaltype/add",
  async (metalData, thunkAPI) => {
    try {
      return await metalService.createMetal(metalData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateAMetal = createAsyncThunk(
  "metaltype/edit",
  async (metal, thunkAPI) => {
    try {
      return await metalService.updateMetal(metal);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAMetal = createAsyncThunk(
  "metaltype/delete",
  async (id, thunkAPI) => {
    try {
      return await metalService.deleteMetal(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  Metal: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const MetalSlice = createSlice({
  name: "Metal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMetal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMetal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Metal = action.payload.result;
        console.log("Fetched metals:", action.payload.result);
      })
      .addCase(getMetal.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createMetal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createMetal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdMetal = action.payload;
      })
      .addCase(createMetal.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAMetal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAMetal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.metalName = action.payload.result.metal_name;
      })
      .addCase(getAMetal.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAMetal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAMetal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedMetal = action.payload;
      })
      .addCase(updateAMetal.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAMetal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAMetal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedMetal = action.payload;
      })
      .addCase(deleteAMetal.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default MetalSlice.reducer;
